import React from 'react';

const Spinner = ({ size = 28, stroke = 4, light = false }) => {
  const c = size / 2;
  const r = (size - stroke) / 2;
  return (
    <span className={`sb-spinner ${light ? 'light' : ''}`} style={{ width: size, height: size }} aria-label="Loading" role="status">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>        
        <circle
          className="track"
          cx={c}
          cy={c}
          r={r}
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          className="indicator"
          cx={c}
          cy={c}
            r={r}
            strokeWidth={stroke}
            fill="none"
            strokeLinecap="round"
        />
      </svg>
    </span>
  );
};

export default Spinner;
